export const VISIBILITY_ITEM_TYPE = {
  ANSWER: 'answer',
  ROW: 'statement',
  COLUMN: 'scale point',
};
